import { FeatureTooltipComponent } from './feature-tooltip.component';

export { FeatureTooltipComponent };
